module.exports = {
  title: 'Steddy Graph Interaction with Skia and Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2023-11-08',
  slug: 'steddy-graph-interaction',
  tags: ['reanimated', 'skia'],
};
